import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = {
  pending: "#ed6c02",
  complete: "#2e7d32",
  expired: "#d32f2f",
};

export default function SocietyComplianceChart({ compliances }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!compliances) return;
    const grouped = compliances.reduce(
      (acc, c) => {
        acc[c.status] = (acc[c.status] || 0) + 1;
        return acc;
      },
      { pending: 0, complete: 0, expired: 0 }
    );

    setData([
      { name: t("Pending"), value: grouped.pending, status: "pending" },
      { name: t("Complete"), value: grouped.complete, status: "complete" },
      { name: t("Expired"), value: grouped.expired, status: "expired" },
    ]);
  }, [compliances, t]);

  return (
    <Grid item xs={12} sm={6} md={6}>
      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={100}
              label
              dataKey="value"
              labelLine={false}
            >
              {data.map((entry) => (
                <Cell key={entry.status} fill={COLORS[entry.status]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend width={300} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Grid>
  );
}
